import React, { createContext, useState, useEffect } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser || null);
    });
    return () => unsubscribe();
  }, []);

  const logout = async () => {
    await signOut(auth);
    setUser(null);
  };

  // Context za lokacijo (SelectionScreen -> Home)
  const [location, setLocation] = useState(null);
  const saveLocationContext = (loc) => setLocation(loc);

  return (
    <AuthContext.Provider value={{ user, setUser, logout, location, saveLocationContext }}>
      {children}
    </AuthContext.Provider>
  );
};